import { createSlice } from '@reduxjs/toolkit';
import { keyBy } from 'lodash';

const initialState = {
	all: null,
};

const doctypesSlice = createSlice({
	name: 'doctypes',
	initialState,
	reducers: {
		setDoctypes: (state, action) => {
			if (action.payload) {
				state.all = action.payload.doctypes;
			}
		},
		resetDoctypes: (state) => {
			state.all = initialState.all;
		},
	},
});

export default doctypesSlice.reducer;
export const { setDoctypes, resetDoctypes } = doctypesSlice.actions;

export const selectAllDoctypes = (state) => state.doctypes.all;
export const selectDoctypeById = (state, doctypeId) => state.doctypes.all?.find((el) => el.id === doctypeId);
export const selectDoctypesByIds = (state, doctypeIds) => {
	if (!doctypeIds) {
		return null;
	}

	const doctypes = state.doctypes.all?.filter((el) => doctypeIds.includes(el.id));
	return keyBy(doctypes, 'id');
};
